import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IfsSchoolService } from '../service/ifs-school.service';

@Component({
  selector: 'app-ifs-school-data',
  templateUrl: './ifs-school-data.component.html',
  styleUrls: ['./ifs-school-data.component.css']
})
export class IfsSchoolDataComponent implements OnDestroy, OnInit {
  private destroy$ = new Subject<void>();
 public schoolData: any;

  constructor(
   private ifsSchoolService: IfsSchoolService
  ) { }

  ngOnInit() {
    this.getIfsSchoolData()
  }
  public getIfsSchoolData(){ 
    this.ifsSchoolService.getSchoolData().pipe(takeUntil(this.destroy$)).subscribe(response => {
      if(response!=="") {
        this.schoolData =response;
      } else {
      }

   } ,
   error => {
     //this.errorAlert =true;
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
